export function TermosDeUsoTab() {
  return (
    <div className="bg-[#15203c] rounded-lg p-4 flex flex-col gap-5">
      {/* Title and Description */}
      <div className="flex flex-col gap-0.5 leading-normal">
        <h2 className="font-['Plus_Jakarta_Sans'] font-bold text-xl text-white">
          Termos de Uso
        </h2>
        <p className="font-['Plus_Jakarta_Sans'] font-normal text-xs text-[#d1d1d1]">
          Verifique e entenda todos os termos
        </p>
      </div>

      {/* Content */}
      <div className="flex flex-col gap-3 text-[#f6f6f6]">
        {/* First Section */}
        <h3 className="font-['Plus_Jakarta_Sans'] font-bold text-lg leading-normal">
          Título do tema e termo
        </h3>

        <div className="font-['Plus_Jakarta_Sans'] font-normal text-sm leading-[1.5]">
          <p className="mb-3">
            Lorem ipsum dolor sit amet consectetur. Quam enim dictum nam at integer nunc nulla.
            Aliquam integer accumsan id sed in sit. Magna morbi ultrices nibh diam imperdiet
            euismod massa ut. Quis vulputate volutpat fermentum malesuada. Tristique nec nunc
            volutpat ipsum ut.
          </p>

          <p className="mb-3">
            Amet facilisis netus mollis at neque ornare dui. Enim posuere amet magna sagittis mauris.
            Turpis aenean malesuada nullam nulla eu metus quam. Vitae neque enim nisi mauris posuere.
            Placerat imperdiet sed cras in morbi placerat id molestie tempor. Ut eu tristique egestas
            cursus tellus nisi risus. Tempor in pellentesque vulputate ornare. Viverra interdum gravida
            varius tellus arcu netus consectetur. Odio ipsum sed fringilla faucibus tempus urna pharetra.
            Neque sociis sed placerat tortor adipiscing vel facilisis sit. Accumsan elit aliquam aliquam
            at in est quam. Nunc quis hendrerit feugiat praesent amet bibendum lobortis.
          </p>

          <p>
            Eget mauris sed viverra accumsan. Scelerisque dignissim diam quis risus mauris. Lectus molestie
            phasellus quam aliquam. Enim in purus fames nibh tortor a. Massa aliquet id elit aliquam mattis id.
            Semper viverra nec interdum vulputate cum posuere.
          </p>
        </div>

        {/* Second Section */}
        <h3 className="font-['Plus_Jakarta_Sans'] font-bold text-lg leading-normal">
          Título do tema e termo
        </h3>

        <div className="font-['Plus_Jakarta_Sans'] font-normal text-sm leading-[1.5]">
          <p className="mb-3">
            Lorem ipsum dolor sit amet consectetur. Quam enim dictum nam at integer nunc nulla.
            Aliquam integer accumsan id sed in sit. Magna morbi ultrices nibh diam imperdiet
            euismod massa ut. Quis vulputate volutpat fermentum malesuada. Tristique nec nunc
            volutpat ipsum ut.
          </p>

          <p className="mb-3">
            Amet facilisis netus mollis at neque ornare dui. Enim posuere amet magna sagittis mauris.
            Turpis aenean malesuada nullam nulla eu metus quam. Vitae neque enim nisi mauris posuere.
            Placerat imperdiet sed cras in morbi placerat id molestie tempor. Ut eu tristique egestas
            cursus tellus nisi risus. Tempor in pellentesque vulputate ornare. Viverra interdum gravida
            varius tellus arcu netus consectetur. Odio ipsum sed fringilla faucibus tempus urna pharetra.
            Neque sociis sed placerat tortor adipiscing vel facilisis sit. Accumsan elit aliquam aliquam
            at in est quam. Nunc quis hendrerit feugiat praesent amet bibendum lobortis.
          </p>

          <p>
            Eget mauris sed viverra accumsan. Scelerisque dignissim diam quis risus mauris. Lectus molestie
            phasellus quam aliquam. Enim in purus fames nibh tortor a. Massa aliquet id elit aliquam mattis id.
            Semper viverra nec interdum vulputate cum posuere.
          </p>
        </div>
      </div>
    </div>
  );
}

TermosDeUsoTab.displayName = "TermosDeUsoTab";
